<template>
  <div id="search-container">
    <div class="">
      <form class="" method="get" action="/pesquisa">
        <div class="">
          <div class="flex justify-between overflow-hidden bg-white rounded-lg">
            <input
              id="search-input"
              class="w-full p-4 rounded"
              autocomplete="off"
              type="search"
              name="search"
              placeholder="O que você procura?"
              v-on:input="debounceSearch"
              required
            />
            <button class="flex gap-2 p-4 font-semibold border-l border-gray-300 text-default-500 hover:bg-default-100 hover:text-default-600" type="submit">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="w-6 h-6" fill="currentColor" >
                <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/>
              </svg>
              {{ messageBtn }}
            </button>
          </div>
          <div class="my-3 overflow-hidden bg-white divide-y rounded-lg shadow" v-show="check">
            <card-search-component v-for="(result, item) in publications" :key="item" :record="result"/>
          </div>
        </div>
        <div class="form-group"></div>
      </form>
    </div>
  </div>
</template>

<script>
import Search from "../api/models/Search";
import { debounce } from "debounce";
import CardSearchComponent from "./CardSearchComponent";

export default {
  name: "SearchComponent",
  components: { CardSearchComponent },
  data() {
    return {
      search: "",
      width: screen.width,
      publications: {},
      total: null,
      check: false,
      messageBtn: "Pesquisar",
    };
  },
  methods: {
    debounceSearch: debounce(function (e) {
      Search.quick(e.target.value).then((response) => {
        this.publications = response.data;
        if (response.total_records > 0) {
          this.total = response.total_records;
          this.check = true;
          this.messageBtn = "Veja todos os " + this.total + " resultados";
        } else {
          this.check = false;
          if (response.total === 0) {
            this.messageBtn = "Nenhum resultado foi encontrado";
          } else {
            this.messageBtn = "Pesquisar";
          }
        }
      });
    }, 400),
    quickSearch(search) {},
    submit() {
      this.$router.push("/pesquisa?search=" + this.search);
    },
  },
};
</script>

<style scoped>
#search-container {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
#search-container .btn-rounded {
  border-radius: 1.5rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
#search-container .form-search {
  height: 3.5rem;
  width: 100%;
  border: none;
  background: #ffffff;
  border-radius: 1.4rem;
  box-shadow: 1px 1px 2px 1px rgba(0, 0, 0, 0.1);
}
#search-container .form-search .form-control {
  height: 3.5rem;
  border: none;
  border-radius: 1.5rem;
  font-size: 1.5rem;
  padding-left: 1.5rem;
}

#search-container .form-search select {
  font-size: 1.2rem !important;
  padding-left: 0.5rem !important;
}
#search-container .form-search input[type="search"]::-webkit-search-decoration,
#search-container
  .form-search
  input[type="search"]::-webkit-search-cancel-button,
#search-container
  .form-search
  input[type="search"]::-webkit-search-results-button,
#search-container
  .form-search
  input[type="search"]::-webkit-search-results-decoration {
  -webkit-appearance: none;
}
#search-container .form-search .form-control:focus {
  outline: none;
}
</style>
